// extracted by mini-css-extract-plugin
export default {"LogoDialog":"LogoDialog_LogoDialog__54d9D","LogoDialog_logo":"LogoDialog_LogoDialog_logo__1imAm"};